import React from 'react';
import styled from 'styled-components';
import { capitalize } from 'library/helpers/text';
import { HoverJourneyTooltip } from 'apps/journey/pages/professional-center/components/hover-journey-tooltip';

export const getLastActionTimestamp = (org) => {
  const actionsList = [
    {
      type: 'approved',
      timestamp: org.approved_timestamp,
      orgName: org.name,
    },
    {
      type: 'denied',
      timestamp: org.denied_timestamp,
      orgName: org.name,
    },
    {
      type: 'requested',
      timestamp: org.requested_timestamp,
      orgName: org.name,
    },
  ];
  return actionsList.sort((a, b) => b.timestamp - a.timestamp)[0];
};

export const getLastActionInAllOrgs = (orgs) => {
  const results = orgs.map((org) => getLastActionTimestamp(org));
  return results.sort((a, b) => b.timestamp - a.timestamp);
};

const formatTimestamp = (timestamp) => {
  let day, time;
  if (timestamp) {
    const date = new Date(parseInt(timestamp));
    const dayOptions = { month: 'short', day: 'numeric', year: 'numeric' };
    const hrMinOptions = { hour: 'numeric', minute: 'numeric' };
    day = date.toLocaleDateString('en-US', dayOptions);
    time = date.toLocaleTimeString('en-US', hrMinOptions);
  }
  return { day, time };
};

const StyledTimestamp = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
`;

const StyledWrapper = styled.div`
  white-space: break-spaces;
  width: 160px;
`;

export const OrgTimestamp = ({ record }) => {
  const result = record?.last_approval_change;
  const { day, time } = formatTimestamp(result?.timestamp);
  return (
    <StyledTimestamp>
      {day && time ? (
        <div>
          {capitalize(result?.type)} on {day + ' at ' + time}
        </div>
      ) : (
        <div>&nbsp;</div>
      )}
    </StyledTimestamp>
  );
};

export const OrgTimestamps = ({ record }) => {
  let result, results;
  results =
    record?.organizations_requests?.length > 0
      ? getLastActionInAllOrgs(record?.organizations_requests)
      : [];
  result = results[0];
  const mappedTimestamps = results.map((res) => {
    const { day, time } = formatTimestamp(res?.timestamp);
    return `${capitalize(res?.type)} in ${res.orgName} on ${day} at ${time}`;
  });
  const { day, time } = formatTimestamp(result?.timestamp);

  return (
    <StyledTimestamp>
      {day && time ? (
        <HoverJourneyTooltip
          activeOnHover
          tip={mappedTimestamps.join('\n')}
          relative
        >
          <StyledWrapper>
            {capitalize(result?.type)} in {result.orgName} on{' '}
            {day + ' at ' + time}
          </StyledWrapper>
        </HoverJourneyTooltip>
      ) : (
        <div>&nbsp;</div>
      )}
    </StyledTimestamp>
  );
};
